import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Read/write helpers that respect "remember me" preference. When the user
// unchecked "Recordarme", credentials live in sessionStorage and evaporate on
// tab close; when checked, they persist in localStorage.
const readAuth = (key) => sessionStorage.getItem(key) || localStorage.getItem(key);
const writeAuthToken = (value) => {
  // Preserve whichever store already held the token; default to localStorage.
  if (sessionStorage.getItem("sdm_token") !== null) sessionStorage.setItem("sdm_token", value);
  else localStorage.setItem("sdm_token", value);
};
const clearAuth = () => {
  ["sdm_token", "sdm_refresh", "sdm_user"].forEach((k) => {
    localStorage.removeItem(k);
    sessionStorage.removeItem(k);
  });
};

api.interceptors.request.use((config) => {
  const token = readAuth("sdm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const status = err?.response?.status;
    const cfg = err.config || {};
    const isLogin = cfg?.url?.includes("/auth/login");
    const isRefresh = cfg?.url?.includes("/auth/refresh");

    // Silent token refresh on 401 (Sprint 33G · Feb 2026). We only retry once
    // per original request; subsequent 401s fall through to the login redirect.
    if (status === 401 && !isLogin && !isRefresh && !cfg._retried) {
      const refresh = readAuth("sdm_refresh");
      if (refresh) {
        try {
          const { data } = await axios.post(
            `${API_BASE}/auth/refresh`,
            { refresh_token: refresh },
            { headers: { "Content-Type": "application/json" } },
          );
          writeAuthToken(data.access_token);
          cfg._retried = true;
          cfg.headers = cfg.headers || {};
          cfg.headers.Authorization = `Bearer ${data.access_token}`;
          return api.request(cfg);
        } catch (_) {
          // refresh itself failed → fall through to redirect
        }
      }
    }

    if (status === 401 && !isLogin) {
      clearAuth();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
